import SelectTargetBranchDialog from './selectTargetBranchDialog.container';

export default SelectTargetBranchDialog